import { OrderLog } from './order-log';

export interface OrderLogsResponse {
  count: number;
  logItems: OrderLog[];
}
